import { render } from "./AttachmentsSegment.vue?vue&type=template&id=238046d7&ts=true"
import script from "./AttachmentsSegment.vue?vue&type=script&lang=ts"
export * from "./AttachmentsSegment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__